import cloneDeep from 'clone-deep'
import { SettingKey } from 'config'
import { useEffect, useState } from 'react'
import { setAdminConfig } from 'services'
import { RenderInput } from 'utils/RenderInput'

import { uiInputs } from './constants'
import { ILoanGlobalSettings } from './interface'

interface IProps {
  globalSetting: ILoanGlobalSettings | undefined
  setAction: (value: string) => void
  setGlobalSetting: (value: ILoanGlobalSettings) => void
}

export const ColorsConfiguration = (props: IProps) => {
  const { globalSetting, setGlobalSetting, setAction } = props

  const [inputs, setInputs] = useState(uiInputs())

  useEffect(() => {
    if (!globalSetting) return
    const newInputs = cloneDeep(inputs)
    Object.keys(newInputs).forEach((key) => {
      newInputs[key].value = globalSetting.ui[key]
    })
    setInputs(newInputs)
  }, [globalSetting])

  const onChange = (key: string, value: string) => {
    const newInputs = cloneDeep(inputs)
    newInputs[key].value = value
    setInputs(newInputs)
  }

  const onBlur = async () => {
    if (!globalSetting) return
    const newSettings = cloneDeep(globalSetting)
    Object.keys(inputs).forEach((key) => {
      newSettings.ui[key] = inputs[key].value
    })
    setAction('setting')
    await setAdminConfig(SettingKey.GLOBAL_SETTINGS, newSettings)
    setGlobalSetting(newSettings)
    setAction('')
  }

  return (
    <div className="relative">
      <div className="input md:col-span-full mb-4">
        <RenderInput
          input={{ inputType: 'section', title: 'UI Configuration' }}
          Key="uiConfigurationSection"
          onChange={() => {}}
        />
      </div>

      <div className="max-w-md flex flex-col gap-4">
        {Object.keys(inputs).map((key) => (
          <RenderInput key={key} input={inputs[key]} Key={key} onChange={onChange} onBlur={onBlur} />
        ))}
      </div>
    </div>
  )
}
